import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
const BASE_URL = 'multi-account/copy-manager/v1';
export const getTargetHubsFieldName = 'targetHubs';
export const GET_TARGET_HUBS = registerQuery({
  fieldName: getTargetHubsFieldName,
  args: [],
  fetcher: () => {
    return http.get(`${BASE_URL}/target-hubs`);
  }
});